import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";
import { saveCoacheesListQuery } from "@/domains/-session/functions/coacheesListQuery";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {GetWorkspaceCoachees, JourneyId, JourneyName, PersonId, WorkspaceId} from "@/sdk.ts";
import {LocationQueryRaw, RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";

export function getDebriefHelperRouteRecord(): RouteRecordRaw {
  return {
    name: 'debrief-helper',
    path: '/workspace/:workspaceId/coachee/:personId/journey/:journeyId/debriefing',
    component: customAsyncComponent(async () => import('./views/DebriefHelperView.vue')),
    meta: {
      hasNav: false,
      requiresAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.ERRORS,
        LOCALE_CATEGORIES.DEBRIEF_HELPER
      ]
    },
  }
}

export function getDebriefHelperRouteLocation(workspaceId: WorkspaceId, personId: PersonId, journeyId: JourneyId, query?: any): RouteLocationRaw {
  return {name: 'debrief-helper', params: {workspaceId, personId, journeyId}, query}
}

export function getDebriefHelperRouteParams(router: Router): { workspaceId: WorkspaceId; personId: PersonId; journeyId: JourneyId} {
  const route = router.currentRoute.value;
  return {
    workspaceId: parseInt(route.params.workspaceId as string, 10),
    personId: route.params.personId as string,
    journeyId: route.params.journeyId as string
  }
}